export const s2t = SECONDS => {
  SECONDS = Math.round(SECONDS / 30) * 30;
  if (SECONDS > 86400) {
    return `${Math.round(SECONDS / 3600)}h`;
  } else if (SECONDS > 3600) {
    return `${Math.floor(SECONDS / 3600)}h ${Math.round((SECONDS % 3600) / 60)}m`;
  } else if (SECONDS > 300) {
    return `${Math.round(SECONDS / 60)}m`;
  } else if (SECONDS > 60) {
    return `${Math.floor(SECONDS / 60)}m ${(SECONDS % 60 !== 0 ? `${(SECONDS % 60)}s` : '')}`;
  } else if (SECONDS === 0) {
    return 0;
  } else {
    return `${SECONDS}s`;
  }
};

export const m2m = KILOMETERS => {
  if (KILOMETERS === 0) {
    return 0;
  }
  KILOMETERS = parseFloat(KILOMETERS);
  return !isNaN(KILOMETERS)
    ? `${(KILOMETERS * 0.000621371192).toFixed(2)}m`
    : `${KILOMETERS}km`;
};
